

const state = {
    team: []
};

const getters = {
    allTeam: (state) => state.team
};


const actions = {
    
    createTeam({ commit }, data ) {
        commit('newTeam', data);
    },
    
    readTeam({ commit }, data ){
        commit('showTeam', data);
    },
    
    updateTeam( { commit }, id){
        commit('changeTeam', id);
    },

    deleteTeam( { commit }, id){
        commit('removeTeam', id);
    },

    
};


const mutations = {
    newTeam: (state, item) => state.team.unshift(item),

    showTeam: (state, item) => state.team = item,

    changeTeam: (state, item) => {
        const index = state.team.findIndex(team => team.id == item.id);
        if (index !== -1) {
            state.team.splice(index, 1, item);
        }
    },

    removeTeam: (state, id) => state.team = state.team.filter(team => team.id !== id),

};


export default {
    state,
    getters,
    actions,
    mutations
};